import { serviceRequest } from './service-request';

export function getThumbprint() {
	let id: string | null = null;
	if (typeof (Storage) !== 'undefined') {
		id = localStorage.getItem('c-user');
		if (!id) {
			id = crypto.randomUUID();
			localStorage.setItem('c-user', id);
		}
	}

	return id;
}

export function adminForgotPassword() {
	return serviceRequest('svc/auth/password/forgot-authenticated', { });
}

export function verifyEmailChange(newEmail: string, password: string) {
	return serviceRequest('svc/auth/email/verify-email-change', { newEmail: newEmail, password: password });
}

export function changeEmail(code: string) {
	return serviceRequest('svc/auth/email/change', { code });
}

export function resendInvitation(userId: string) {
	return serviceRequest('svc/auth/invite/resend-invitation', { userId }, { method: 'POST' });
}

export function getVerificationInfo() {
	return serviceRequest('svc/auth/verify/get-verification-info', null, { method: 'GET' });
}

export function getOauthConnectionOptions () {
	return serviceRequest('svc/integration/oauth/connection-options', null, { method: 'GET' });
}

export function resendUserVerificationEmail() {
	return serviceRequest('svc/auth/verify/resend-verify-email', null, { method: 'POST' });
}